import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function StudentDashboard() {
  const [user] = useState({
    name: '김학습',
    email: 'student@example.com',
    studentId: 'STU-2024-001'
  });

  const [certificates] = useState([
    {
      id: 'CERT-2024-001',
      name: '디지털 마케팅 전문가',
      type: 'certificate',
      issuer: '한국디지털교육원',
      issueDate: '2024-01-20',
      expiryDate: '2024-03-05',
      daysUntilExpiry: 15,
      daysLeft: 15,
      status: 'active',
      isPaid: true,
      printCount: 2,
      maxPrintCount: 3,
      printLimit: '3',
      printCost: 5000,
      thumbnail: 'https://public.readdy.ai/ai/img_res/4be4fffcc9149a8ea85623e8bb670276.jpg'
    },
    {
      id: 'CERT-2024-002',
      name: 'React 개발 과정',
      type: 'completion',
      issuer: '코드아카데미',
      issueDate: '2024-01-15',
      expiryDate: '평생 유효',
      daysUntilExpiry: null,
      daysLeft: null,
      status: 'active',
      isPaid: false,
      printCount: 0,
      maxPrintCount: 0,
      printLimit: '무제한',
      printCost: '무료',
      thumbnail: 'https://readdy.ai/api/search-image?query=react%20programming%20course%20completion%20certificate%20with%20tech%20theme%2C%20modern%20gradient%20design%2C%20professional%20layout&width=600&height=400&seq=cert2&orientation=landscape'
    },
    {
      id: 'CERT-2024-003',
      name: 'UI/UX 디자인 전문가',
      type: 'certificate',
      issuer: '디자인스쿨',
      issueDate: '2023-12-10',
      expiryDate: '2024-12-10',
      daysUntilExpiry: 280,
      daysLeft: 280,
      status: 'active',
      isPaid: true,
      printCount: 1,
      maxPrintCount: 5,
      printLimit: '5',
      printCost: 7000,
      thumbnail: 'https://readdy.ai/api/search-image?query=UI%20UX%20design%20certificate%20with%20creative%20colorful%20elements%2C%20modern%20professional%20design%2C%20clean%20layout&width=600&height=400&seq=cert3&orientation=landscape'
    },
    {
      id: 'CERT-2024-004',
      name: '데이터 분석 실무',
      type: 'completion',
      issuer: '데이터사이언스센터',
      issueDate: '2024-01-10',
      expiryDate: '2024-02-25',
      daysUntilExpiry: 5,
      daysLeft: 5,
      status: 'active',
      isPaid: true,
      printCount: 3,
      maxPrintCount: 3,
      printLimit: '3',
      printCost: 6000,
      thumbnail: 'https://readdy.ai/api/search-image?query=data%20analysis%20certificate%20with%20charts%20and%20graphs%20theme%2C%20professional%20blue%20design%2C%20modern%20layout&width=600&height=400&seq=cert4&orientation=landscape'
    },
    {
      id: 'CERT-2024-005',
      name: 'Python 프로그래밍',
      type: 'completion',
      issuer: '프로그래밍스쿨',
      issueDate: '2023-11-20',
      expiryDate: '평생 유효',
      daysUntilExpiry: null,
      daysLeft: null,
      status: 'active',
      isPaid: false,
      printCount: 0,
      maxPrintCount: 0,
      printLimit: '무제한',
      printCost: '무료',
      thumbnail: 'https://readdy.ai/api/search-image?query=python%20programming%20certificate%20with%20code%20theme%2C%20modern%20tech%20design%2C%20professional%20green%20accents&width=600&height=400&seq=cert5&orientation=landscape'
    },
    {
      id: 'CERT-2024-006',
      name: '프로젝트 관리 전문가',
      type: 'certificate',
      issuer: 'PM아카데미',
      issueDate: '2023-10-15',
      expiryDate: '2024-10-15',
      daysUntilExpiry: 228,
      daysLeft: 228,
      status: 'active',
      isPaid: true,
      printCount: 0,
      maxPrintCount: 4,
      printLimit: '4',
      printCost: 8000,
      thumbnail: 'https://readdy.ai/api/search-image?query=project%20management%20certificate%20with%20professional%20business%20theme%2C%20elegant%20design%2C%20modern%20layout&width=600&height=400&seq=cert6&orientation=landscape'
    }
  ]);

  const [activeFilter, setActiveFilter] = useState<'all' | 'certificate' | 'completion'>('all');
  const [showPDFModal, setShowPDFModal] = useState(false);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState<any>(null);

  const handlePrint = (cert: any) => {
    // 인쇄 잔여 횟수 확인
    if (cert.isPaid && cert.printCount >= cert.maxPrintCount) {
      // 인쇄 횟수 초과 - 결제 필요
      setSelectedCertificate(cert);
      setShowPaymentModal(true);
      return;
    }
    
    setSelectedCertificate(cert);
    setShowPrintModal(true);
  };

  const handleViewDetail = (cert: any) => {
    setSelectedCertificate(cert);
    setShowDetailModal(true);
  };

  const handleDownloadPDF = () => {
    setShowPDFModal(true);
  };

  const confirmDownloadPDF = () => {
    // PDF 다운로드 로직
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
        <head>
          <title>증명서 보관함 - ${user.name}</title>
          <style>
            body { font-family: 'Pretendard', sans-serif; padding: 40px; }
            h1 { color: #1e293b; margin-bottom: 30px; }
            .cert-item { margin-bottom: 20px; padding: 20px; border: 1px solid #e2e8f0; border-radius: 8px; }
            .cert-title { font-size: 18px; font-weight: bold; color: #0f172a; }
            .cert-info { margin-top: 10px; color: #64748b; }
          </style>
        </head>
        <body>
          <h1>증명서 보관함 - ${user.name}</h1>
          ${certificates.map(cert => `
            <div class="cert-item">
              <div class="cert-title">${cert.name}</div>
              <div class="cert-info">발급기관: ${cert.issuer}</div>
              <div class="cert-info">발급일: ${cert.issueDate}</div>
              ${cert.expiryDate ? `<div class="cert-info">만료일: ${cert.expiryDate}</div>` : ''}
              <div class="cert-info">증명서 번호: ${cert.id}</div>
            </div>
          `).join('')}
        </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
    setShowPDFModal(false);
  };

  const confirmPrint = () => {
    if (selectedCertificate) {
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
          <head>
            <title>${selectedCertificate.name}</title>
            <style>
              body { 
                font-family: 'Pretendard', sans-serif; 
                padding: 60px; 
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 100vh;
              }
              .certificate { 
                border: 3px solid #1e293b; 
                padding: 60px; 
                text-align: center;
                max-width: 800px;
              }
              h1 { font-size: 36px; margin-bottom: 40px; color: #0f172a; }
              .info { margin: 20px 0; font-size: 18px; color: #475569; }
            </style>
          </head>
          <body>
            <div class="certificate">
              <h1>${selectedCertificate.name}</h1>
              <div class="info">발급기관: ${selectedCertificate.issuer}</div>
              <div class="info">발급일: ${selectedCertificate.issueDate}</div>
              ${selectedCertificate.expiryDate ? `<div class="info">만료일: ${selectedCertificate.expiryDate}</div>` : ''}
              <div class="info">증명서 번호: ${selectedCertificate.id}</div>
            </div>
          </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
      }
      setShowPrintModal(false);
      setSelectedCertificate(null);
    }
  };

  // 필터링된 증명서 목록
  const filteredCertificates = activeFilter === 'all' 
    ? certificates 
    : certificates.filter(cert => cert.type === activeFilter);

  // 통계 계산 (영문 타입으로 수정)
  const totalCertificates = certificates.length;
  const certificateCount = certificates.filter(c => c.type === 'certificate').length;
  const completionCount = certificates.filter(c => c.type === 'completion').length;
  const expiringCount = certificates.filter(c => c.daysLeft !== null && c.daysLeft <= 30).length;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-indigo-950">
      {/* 헤더 */}
      <header className="bg-slate-950/50 backdrop-blur-xl border-b border-white/10 sticky top-0 z-50 h-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/01721397da55af21878e201cee4469af/22d693b8e5c7b9a7815f6764c73619aa.png" 
              alt="CEIS Logo" 
              className="h-8"
            />
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <p className="text-xs text-slate-400 font-medium">Verified User</p>
              <p className="text-sm font-bold text-white">{user?.name || '김학습'}</p>
            </div>
            <div className="w-9 h-9 bg-white/5 backdrop-blur-md rounded-full border border-white/10 flex items-center justify-center hover:bg-white/10 transition-all cursor-pointer">
              <i className="ri-user-line w-5 h-5 text-slate-300"></i>
            </div>
          </div>
        </div>
      </header>

      {/* 메인 컨텐츠 */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* 타이틀 및 액션 */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-2xl font-bold text-white">내 증명서 보관함</h2>
            <p className="text-slate-400 text-sm mt-1">발급된 모든 자격 증명을 안전하게 보관하고 관리합니다.</p>
          </div>
          <button 
            onClick={handleDownloadPDF}
            className="px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg text-sm font-medium hover:from-blue-600 hover:to-purple-700 transition shadow-lg shadow-blue-500/30 flex items-center whitespace-nowrap cursor-pointer"
          >
            <i className="ri-printer-line w-4 h-4 mr-2"></i> PDF 저장
          </button>
        </div>

        {/* 통계 카드 - 프리미엄 디자인 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {/* 전체 증명서 */}
          <div className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-blue-500/10 via-blue-600/5 to-transparent border border-blue-500/20 hover:border-blue-400/40 transition-all duration-300 hover:shadow-2xl hover:shadow-blue-500/20">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative p-6">
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <p className="text-sm font-medium text-blue-300/80 mb-1">전체 증명서</p>
                  <p className="text-4xl font-bold text-white tracking-tight">{certificates.length}</p>
                </div>
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center shadow-lg shadow-blue-500/30 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-file-list-3-line text-2xl text-white"></i>
                </div>
              </div>
              <div className="flex items-center text-xs text-blue-300/60">
                <i className="ri-arrow-right-line mr-1"></i>
                <span>모든 증명서 보기</span>
              </div>
            </div>
          </div>

          {/* 자격증 */}
          <div className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-emerald-500/10 via-emerald-600/5 to-transparent border border-emerald-500/20 hover:border-emerald-400/40 transition-all duration-300 hover:shadow-2xl hover:shadow-emerald-500/20">
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative p-6">
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <p className="text-sm font-medium text-emerald-300/80 mb-1">자격증</p>
                  <p className="text-4xl font-bold text-white tracking-tight">
                    {certificates.filter(c => c.type === 'certificate').length}
                  </p>
                </div>
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center shadow-lg shadow-emerald-500/30 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-award-line text-2xl text-white"></i>
                </div>
              </div>
              <div className="flex items-center text-xs text-emerald-300/60">
                <i className="ri-checkbox-circle-line mr-1"></i>
                <span>전문 자격 인증</span>
              </div>
            </div>
          </div>

          {/* 수료증 */}
          <div className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-purple-500/10 via-purple-600/5 to-transparent border border-purple-500/20 hover:border-purple-400/40 transition-all duration-300 hover:shadow-2xl hover:shadow-purple-500/20">
            <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative p-6">
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <p className="text-sm font-medium text-purple-300/80 mb-1">수료증</p>
                  <p className="text-4xl font-bold text-white tracking-tight">
                    {certificates.filter(c => c.type === 'completion').length}
                  </p>
                </div>
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center shadow-lg shadow-purple-500/30 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-medal-line text-2xl text-white"></i>
                </div>
              </div>
              <div className="flex items-center text-xs text-purple-300/60">
                <i className="ri-graduation-cap-line mr-1"></i>
                <span>교육 과정 이수</span>
              </div>
            </div>
          </div>

          {/* 만료 임박 */}
          <div className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-amber-500/10 via-amber-600/5 to-transparent border border-amber-500/20 hover:border-amber-400/40 transition-all duration-300 hover:shadow-2xl hover:shadow-amber-500/20">
            <div className="absolute inset-0 bg-gradient-to-br from-amber-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative p-6">
              <div className="flex items-start justify-between mb-4">
                <div className="flex-1">
                  <p className="text-sm font-medium text-amber-300/80 mb-1">만료 임박</p>
                  <p className="text-4xl font-bold text-white tracking-tight">
                    {certificates.filter(c => {
                      const daysLeft = Math.floor((new Date(c.expiryDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
                      return daysLeft <= 30 && daysLeft > 0;
                    }).length}
                  </p>
                </div>
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center shadow-lg shadow-amber-500/30 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-time-line text-2xl text-white"></i>
                </div>
              </div>
              <div className="flex items-center text-xs text-amber-300/60">
                <i className="ri-alert-line mr-1"></i>
                <span>30일 이내 만료</span>
              </div>
            </div>
          </div>
        </div>

        {/* 필터 버튼 */}
        <div className="flex gap-3 mb-8 flex-wrap">
          <button 
            onClick={() => setActiveFilter('all')}
            className={`px-5 py-2.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              activeFilter === 'all' 
                ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg shadow-blue-500/30' 
                : 'bg-white/5 backdrop-blur-md border border-white/10 text-slate-300 hover:bg-white/10'
            }`}
          >
            <i className="ri-apps-line mr-2"></i>전체 보기 ({totalCertificates})
          </button>
          <button 
            onClick={() => setActiveFilter('certificate')}
            className={`px-5 py-2.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              activeFilter === 'certificate' 
                ? 'bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg shadow-indigo-500/30' 
                : 'bg-white/5 backdrop-blur-md border border-white/10 text-slate-300 hover:bg-white/10'
            }`}
          >
            <i className="ri-award-line mr-2"></i>자격증 ({certificateCount})
          </button>
          <button 
            onClick={() => setActiveFilter('completion')}
            className={`px-5 py-2.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              activeFilter === 'completion' 
                ? 'bg-gradient-to-r from-emerald-500 to-teal-600 text-white shadow-lg shadow-emerald-500/30' 
                : 'bg-white/5 backdrop-blur-md border border-white/10 text-slate-300 hover:bg-white/10'
            }`}
          >
            <i className="ri-medal-line mr-2"></i>수료증 ({completionCount})
          </button>
        </div>

        {/* 증명서 카드 그리드 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredCertificates.map((cert) => (
            <div 
              key={cert.id}
              className={`bg-slate-900/80 backdrop-blur-sm rounded-2xl border border-white/10 overflow-hidden transition-all duration-300 group flex flex-col ${
                cert.type === 'certificate' 
                  ? 'hover:border-indigo-500/50 hover:shadow-[0_0_30px_rgba(99,102,241,0.15)]'
                  : 'hover:border-emerald-500/50 hover:shadow-[0_0_30px_rgba(16,185,129,0.15)]'
              }`}
            >
              {/* 이미지 영역 */}
              <div className="h-48 bg-slate-950 relative overflow-hidden border-b border-white/5">
                {/* 썸네일 이미지 */}
                <img 
                  src={cert.thumbnail} 
                  alt={cert.name}
                  className="w-full h-full object-cover"
                />
                
                {/* 오버레이 그라데이션 */}
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent"></div>
                
                {/* 배지 */}
                <span className={`absolute top-4 left-4 text-white text-[11px] font-bold px-2.5 py-1 rounded shadow-lg border ${
                  cert.type === 'certificate'
                    ? 'bg-indigo-600 shadow-indigo-900/50 border-indigo-400/30'
                    : 'bg-emerald-600 shadow-emerald-900/50 border-emerald-400/30'
                }`}>
                  {cert.type === 'certificate' ? '자격증' : '수료증'}
                </span>
                
                {/* 만료 임박 배지 */}
                {cert.daysLeft !== null && cert.daysLeft <= 30 && (
                  <div className="absolute bottom-4 right-4 bg-orange-600/90 backdrop-blur text-white text-[11px] font-bold px-3 py-1.5 rounded shadow-lg flex items-center border border-orange-400/30">
                    <i className="ri-alarm-warning-line mr-1.5"></i> D-{cert.daysLeft} 만료 임박
                  </div>
                )}
              </div>

              {/* 컨텐츠 영역 */}
              <div className="p-6 flex-1 flex flex-col">
                <h3 className={`text-xl font-bold text-white mb-1 transition-colors ${
                  cert.type === 'certificate' ? 'group-hover:text-indigo-400' : 'group-hover:text-emerald-400'
                }`}>
                  {cert.name}
                </h3>
                <div className="flex items-center text-sm text-slate-400 mb-5">
                  <i className="ri-building-line mr-1.5 text-slate-500"></i>
                  {cert.issuer}
                </div>
                
                {/* 정보 박스 */}
                <div className="bg-slate-800/50 rounded-xl p-4 mb-6 space-y-2 text-[13px] text-slate-300 border border-white/5">
                  <div className="flex justify-between">
                    <span className="text-slate-500">발급 날짜</span>
                    <span className="font-medium">{cert.issueDate}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">유효 기간</span>
                    <span className={`font-medium ${cert.expiryDate === '평생 유효' ? 'text-emerald-400' : 'text-slate-200'}`}>
                      {cert.expiryDate === '평생 유효' ? '∞ 평생 유효' : `~${cert.expiryDate}`}
                      {cert.daysLeft !== null && cert.daysLeft <= 30 && (
                        <span className="text-orange-400 ml-1 font-bold drop-shadow-sm">({cert.daysLeft}일 남음)</span>
                      )}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">인쇄 잔여</span>
                    <span className={`font-medium ${cert.printLimit === '무제한' ? 'text-emerald-400' : ''}`}>
                      {cert.printLimit === '무제한' ? '∞ 무제한' : `${cert.printCount} / ${cert.printLimit}회`}
                    </span>
                  </div>
                  <div className="flex justify-between pt-1 border-t border-white/10 mt-1">
                    <span className="text-slate-500">인쇄 비용</span>
                    <span className={`font-bold ${cert.printCost === '무료' ? 'text-slate-300' : 'text-indigo-400'}`}>
                      {cert.printCost}
                    </span>
                  </div>
                </div>

                {/* 버튼 그룹 */}
                <div className="mt-auto flex gap-2 h-11">
                  {cert.isPaid && cert.printCount >= cert.maxPrintCount ? (
                    // 인쇄 횟수 초과 - 결제 필요
                    <button 
                      onClick={() => handlePrint(cert)}
                      className="flex-1 bg-gradient-to-r from-orange-600 to-red-600 hover:from-orange-500 hover:to-red-500 text-white font-medium rounded-lg transition flex items-center justify-center shadow-lg shadow-orange-900/50 border border-white/10 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-shopping-cart-line mr-2"></i> 유료 결제
                    </button>
                  ) : (
                    // 일반 인쇄 버튼
                    <button 
                      onClick={() => handlePrint(cert)}
                      className="flex-1 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white font-medium rounded-lg transition flex items-center justify-center shadow-lg shadow-indigo-900/50 border border-white/10 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-printer-line mr-2"></i> 인쇄
                    </button>
                  )}
                  <button 
                    onClick={() => handleViewDetail(cert)}
                    className="w-12 bg-transparent border border-slate-600 hover:bg-slate-800 hover:border-slate-500 text-slate-300 hover:text-white rounded-lg transition flex items-center justify-center cursor-pointer"
                  >
                    <i className="ri-eye-line text-lg"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 결과 없음 메시지 */}
        {filteredCertificates.length === 0 && (
          <div className="text-center py-20">
            <div className="w-20 h-20 bg-white/5 rounded-full mx-auto mb-4 flex items-center justify-center">
              <i className="ri-file-list-3-line text-4xl text-slate-500"></i>
            </div>
            <p className="text-slate-400 text-lg">해당하는 증명서가 없습니다</p>
          </div>
        )}
      </main>

      {/* 결제 모달 */}
      {showPaymentModal && selectedCertificate && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-slate-900/95 backdrop-blur-xl border border-white/20 rounded-2xl max-w-md w-full p-6 shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-white">유료 결제</h3>
              <button
                onClick={() => setShowPaymentModal(false)}
                className="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/10 rounded-lg transition-all cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            
            <div className="mb-6">
              <p className="text-slate-400 mb-4">
                <strong className="text-white">{selectedCertificate.name}</strong> 증명서의 인쇄 가능 횟수를 모두 사용했습니다.
              </p>
              
              <div className="bg-orange-500/10 border border-orange-500/30 rounded-lg p-4 mb-4">
                <div className="flex items-center text-orange-300 mb-2">
                  <i className="ri-information-line mr-2"></i>
                  <span className="font-medium">현재 상태</span>
                </div>
                <p className="text-orange-200 text-sm">
                  사용 횟수: {selectedCertificate.printCount} / {selectedCertificate.maxPrintCount}회
                </p>
              </div>

              <div className="bg-indigo-500/10 border border-indigo-500/30 rounded-lg p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-indigo-300 font-medium">추가 인쇄 1회</span>
                  <span className="text-indigo-300 font-bold text-lg">{selectedCertificate.printCost.toLocaleString()}원</span>
                </div>
                <p className="text-indigo-200/70 text-xs">
                  결제 후 즉시 인쇄 가능합니다
                </p>
              </div>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => setShowPaymentModal(false)}
                className="flex-1 px-4 py-2 bg-white/5 backdrop-blur-md border border-white/10 text-slate-300 rounded-lg font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                취소
              </button>
              <button
                onClick={() => {
                  // 결제 처리 로직 (Stripe 연동 필요)
                  alert(`${selectedCertificate.printCost.toLocaleString()}원 결제가 진행됩니다.`);
                  setShowPaymentModal(false);
                }}
                className="flex-1 px-4 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg font-medium hover:from-indigo-500 hover:to-purple-500 transition-all shadow-lg shadow-indigo-500/30 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-cart-line mr-2"></i>
                결제하기
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 인쇄 확인 모달 */}
      {showPrintModal && selectedCertificate && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-slate-900/95 backdrop-blur-xl border border-white/20 rounded-2xl max-w-md w-full p-6 shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-white">증명서 인쇄</h3>
              <button
                onClick={() => setShowPrintModal(false)}
                className="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/10 rounded-lg transition-all cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <p className="text-slate-400 mb-6">
              <strong className="text-white">{selectedCertificate.name}</strong> 증명서를 인쇄하시겠습니까?
            </p>
            {selectedCertificate.printCost > 0 && (
              <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4 mb-6">
                <p className="text-blue-300 text-sm">
                  인쇄 비용: <strong>{selectedCertificate.printCost.toLocaleString()}원</strong>
                </p>
                <p className="text-blue-300 text-sm mt-1">
                  잔여 횟수: <strong>{selectedCertificate.maxPrintCount - selectedCertificate.printCount}회</strong>
                </p>
              </div>
            )}
            <div className="flex gap-3">
              <button
                onClick={() => setShowPrintModal(false)}
                className="flex-1 px-4 py-2 bg-white/5 backdrop-blur-md border border-white/10 text-slate-300 rounded-lg font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                취소
              </button>
              <button
                onClick={confirmPrint}
                className="flex-1 px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 transition-all shadow-lg shadow-blue-500/30 whitespace-nowrap cursor-pointer"
              >
                인쇄
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 상세보기 모달 */}
      {showDetailModal && selectedCertificate && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-slate-900/95 backdrop-blur-xl border border-white/20 rounded-2xl max-w-2xl w-full p-6 shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-white">증명서 상세 정보</h3>
              <button
                onClick={() => setShowDetailModal(false)}
                className="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/10 rounded-lg transition-all cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            
            <div className="space-y-4">
              <div className="bg-slate-800/50 rounded-xl p-4 border border-white/5">
                <h4 className="text-sm font-medium text-slate-400 mb-2">증명서 정보</h4>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-slate-500">증명서명:</span>
                    <span className="text-white font-medium">{selectedCertificate.name}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">발급기관:</span>
                    <span className="text-white font-medium">{selectedCertificate.issuer}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">증명서 번호:</span>
                    <span className="text-white font-medium font-mono text-xs">{selectedCertificate.id}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-500">발급일:</span>
                    <span className="text-white font-medium">{selectedCertificate.issueDate}</span>
                  </div>
                  {selectedCertificate.expiryDate && (
                    <div className="flex justify-between">
                      <span className="text-slate-500">만료일:</span>
                      <span className="text-white font-medium">{selectedCertificate.expiryDate}</span>
                    </div>
                  )}
                </div>
              </div>

              {selectedCertificate.printCost > 0 && (
                <div className="bg-indigo-500/10 border border-indigo-500/30 rounded-xl p-4">
                  <h4 className="text-sm font-medium text-indigo-300 mb-2">인쇄 정보</h4>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-indigo-200/70">인쇄 비용:</span>
                      <span className="text-indigo-300 font-bold">{selectedCertificate.printCost.toLocaleString()}원/회</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-indigo-200/70">잔여 횟수:</span>
                      <span className="text-indigo-300 font-bold">{selectedCertificate.maxPrintCount - selectedCertificate.printCount}회</span>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex gap-3 mt-6">
              <button
                onClick={() => setShowDetailModal(false)}
                className="flex-1 px-4 py-2 bg-white/5 backdrop-blur-md border border-white/10 text-slate-300 rounded-lg font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                닫기
              </button>
              <button
                onClick={() => {
                  setShowDetailModal(false);
                  handlePrint(selectedCertificate);
                }}
                className="flex-1 px-4 py-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg font-medium hover:from-indigo-500 hover:to-purple-500 transition-all shadow-lg shadow-indigo-500/30 whitespace-nowrap cursor-pointer"
              >
                인쇄하기
              </button>
            </div>
          </div>
        </div>
      )}

      {/* PDF 다운로드 모달 */}
      {showPDFModal && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-slate-900/95 backdrop-blur-xl border border-white/20 rounded-2xl max-w-md w-full p-6 shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold text-white">PDF 저장</h3>
              <button
                onClick={() => setShowPDFModal(false)}
                className="w-8 h-8 flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/10 rounded-lg transition-all cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <p className="text-slate-400 mb-6">
              모든 증명서를 PDF 파일로 저장하시겠습니까?
            </p>
            <div className="flex gap-3">
              <button
                onClick={() => setShowPDFModal(false)}
                className="flex-1 px-4 py-2 bg-white/5 backdrop-blur-md border border-white/10 text-slate-300 rounded-lg font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
              >
                취소
              </button>
              <button
                onClick={confirmDownloadPDF}
                className="flex-1 px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 transition-all shadow-lg shadow-blue-500/30 whitespace-nowrap cursor-pointer"
              >
                저장
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
